export const pageSizeOptions = [
  {
    label: '25',
    value: 25,
  },
  {
    label: '50',
    value: 50,
  },
]
